import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FileUploader } from 'react-drag-drop-files';
import { LuUpload } from 'react-icons/lu';
import pdfToText from "react-pdftotext";
import { queryByIdAPI } from '../../containers/User/Calculator/api';
import * as calculatorActions from "../../containers/User/Calculator/actions";

export default function UploadPDFModal(props) {
    const { handleClose, title = "Import Cargo Details from PDF or CSV", setPortOperations, setQuery, query, open } = props;
    const [error, setError] = useState("");
    const [fileUploading, setFileUploading] = useState("");



    const fileTypes = ["PDF", "CSV"];
    const handleChange = async (file) => {
        setFileUploading("File Uploading...");
        
        // Handle AI CSV upload
        if (file.name.toLowerCase().endsWith(".csv")) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const csvText = e.target.result;
                const { validateAIImportCSV } = await import("../../util/aiImport/aiImportValidator");
                const { applyValidCargo } = await import("../../util/aiImport/aiImportMapper");

                const validation = validateAIImportCSV(csvText);
                if (validation.isValid) {
                    const unresolvedCount = await applyValidCargo(validation.data, {
                        query, portOperations: props.portOperations, setQuery, setPortOperations, onStatus: setFileUploading,
                    });
                    if (unresolvedCount > 0) {
                        setFileUploading(`AI Import Partially Successful. ${unresolvedCount} port(s) require manual confirmation!`);
                    } else {
                        setFileUploading("AI Import Successfully Applied!");
                    }
                    setError("");
                } else {
                    setError(validation.error);
                    setFileUploading("");
                }
            };
            reader.readAsText(file);
            return;
        }

        // Handle existing PDF upload
        const queryid = await pdfToText(file)
            .then((text) => {
                const startIndex = text.indexOf("cargoqueryid-");
                const endIndex = text.indexOf("#", startIndex);
                if (startIndex !== -1 && endIndex !== -1) {
                    let substring = text.substring(startIndex + "cargoqueryid-".length, endIndex);
                    substring = substring.replace(/\s+/g, "");
                    return substring;
                }
                return "";
            }).catch(() => setError("invalid file! Please upload valid file"));
        if (!queryid) {
            setError("invalid file! Please upload valid file")
            return
        } else {
            setError("")
        }
        try {
            const details = await calculatorActions.queryByPDFdownload(queryid)
            if (details?.success) {
                setQuery({ ...query, name: details?.data?.name, freightMode: details?.data?.freightMode, qtyMode: details?.data?.qtyMode, access: details?.data?.access, laycanStartDate: details?.data?.laycanStartDate, laycanEndDate: details?.data?.laycanEndDate, message: details?.data?.message })
                setPortOperations(details?.data?.portOperations?.filter(itm => itm?.operation === "Loading" || itm?.operation === "Discharging"))
                setFileUploading("File Uploaded Successfully!")
            } else {
                setError("invalid file! Please upload valid file")
            }
        } catch (err) {
            setError("Something went wrong!")
        }
    };
    const CustomSection = () => {
        return (
            <div className="upload-container" id="drop-area">
                <LuUpload size={18} aria-hidden="true" />
                <span className="upload-container-title">Choose a file or drag it here</span>
                {!error && <p aria-live="polite">{fileUploading || "PDF or CSV"}</p>}
                {error && <p className="!text-rose-600" role="alert">{error}</p>}
            </div>
        )
    }
    const onClose = () => {
        handleClose()
        setError("")
        setFileUploading("")
    }
    return (
        <div>
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                onClose={() => onClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className="font-family">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText component="div" id="alert-dialog-description" className="font-family">
                        <FileUploader classes="pdf-upload-trigger" dropMessageStyle={{ color: "#000", backgroundColor: 'red' }} children={<CustomSection />} multiple={false} handleChange={handleChange} name="file" label="Upload or drop a file right here" types={fileTypes} />
                    </DialogContentText>
                    <div className="mt-3 border border-slate-200 bg-slate-50 px-3 py-2 text-[12px] text-slate-700 space-y-2">
                        <div className="font-semibold text-slate-900">Where to get an import file</div>
                        <div><strong className="text-slate-900">PDF:</strong> In Orders &gt; My Orders, open a saved cargo order and choose Download PDF. Then upload that PDF here.</div>
                        <div><strong className="text-slate-900">CSV:</strong> In the New Cargo form, choose Export AI Instruction PDF beside Upload PDF or CSV. Give that instruction PDF and your source documents to an AI assistant, then upload the CSV it produces here.</div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClose()} color="primary" className="font-family" autoFocus>
                        {fileUploading ? "Confirm" : "Cancel"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
